import { Component, Input, OnInit } from "@angular/core";
import { constantUrl } from "src/app/Shared/constantUrl";
import { LmsService } from "../../services/lms.service";

@Component({
  selector: "app-print-card",
  templateUrl: "./print-card.component.html",
  styleUrls: ["./print-card.component.scss"],
})
export class PrintCardComponent implements OnInit {
  @Input() loanId;
  @Input() resData;
  @Input() applicationId;
  object = Object;
  gstDetail: any;
  originalData: any = {};

  EmployeeProfileBaseUrl: any = constantUrl.apiProfilePicUrl;
  isShown: boolean;

  constructor(private lmsService: LmsService) {}

  ngOnInit(): void {
    this.getCompanyName();
    this.isShown = false;
  }
  getCompanyName() {
    this.lmsService
      .GSTReceiptDetails({ LoanId: this.loanId, VoucherId: 0 })
      .subscribe((result: any) => {
        // console.log("Receipt Details : ", result);
        this.originalData = result.Item1[0];
      });
  }
}
